import { Component, OnInit, AfterContentInit } from '@angular/core';
import { FormGroup, Validators, FormControl, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UsuarioService } from 'src/app/services/usuario.service';
import { UsuarioAutorizacoes } from 'src/app/models/usuario.autorizacoes.model';
import { EquipamentoRdService } from 'src/app/services/equipamento-rd.service';

@Component({
  selector: 'app-equipamento-rd',
  templateUrl: './equipamento-rd.component.html',
  styleUrls: ['./equipamento-rd.component.sass']
})

export class EquipamentoRdComponent implements OnInit, AfterContentInit {


  public cadastrados: any[] = [];

  public form: FormGroup = null;
  public id = 0; // representa o id do modelo. Se 0 novo cadastro, Se > 0 editando
  public isProcessing = false;
  public isEditing = false;
  public voids: string[] = [];
  public maxRowsVoids = 7;

  public autorizacoes: UsuarioAutorizacoes;

  constructor(
    private equipamentoRDService: EquipamentoRdService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private usuarioService: UsuarioService, 
    private formBuilder: FormBuilder,

  ) { }

  ngAfterContentInit(): void {
    this.autorizacoes = this.usuarioService.getAutorizacoesJanelaPorRota('equipamento-rd');
  }

  ngOnInit() {
    this.getAll(); // carrega lista de já cadastrados
    this.resetForm(); // instancia o formulário utilizado (formGroup)
  }

  public getAll(): void {
    this.equipamentoRDService.getAll().subscribe((response: any) => {
      this.cadastrados = response;
      this.setVoids();
    });
  }

  public resetForm(): void {
    this.form = this.formBuilder.group(
      {
        id: [0],
        nome: [null, [Validators.required]]
      });

      this.isEditing = false;

  }

  public reset(): void {
    this.isProcessing = false;
    this.isEditing = false;
    this.resetForm();
  }

  public getById(id: number): void {

    this.reset();
    this.isProcessing = true;

    this.equipamentoRDService.getById(id).subscribe(

      (response: any) => {
        this.form.patchValue({
          id: response.id,
          nome: response.nome
        });

        this.isEditing = true;
        this.isProcessing = false;
      },
      (error: any) => {
        this.showError(error);
      },
    );
  }

  public submit(): void {

    this.isProcessing = true;

    if (this.form.get('id').value === 0) {
      this.equipamentoRDService.isUniqueNome(this.form.get('nome').value, this.form.get('id').value).subscribe(

        (isUniqueNome: boolean) => {

          if (isUniqueNome) {
            this.save();
          } else {
            this.form.get('nome').setErrors({ isNotUniqueNome: true });
            this.isProcessing = false;
          }
        },
        (error: any) => { this.showError(error); }
      );
    } else {
      this.save();
    }

  }

  private save() {
    this.equipamentoRDService.add(this.form.value).subscribe(

      (response: any) => {

        if (response.success == true) {
          this.toastr.success(response.message);
        } else {
          this.toastr.warning(response.message);
        }
        this.reset();
        this.getAll();
      },
      (error: any) => {
        this.showError(error);
      }
    );

  }


  public setVoids(): void {
    this.voids = [];
    if (this.cadastrados.length < this.maxRowsVoids) {
      for (let i = this.cadastrados.length; i < this.maxRowsVoids; i++) { this.voids.push(''); }
    }
  }

  public showModalSm(modal: any) {
    this.modalService.open(modal, { windowClass: 'smModal', backdrop: 'static'  });
  }

  public delete(id: number, c: any): void {

    this.isProcessing = true;
    c('Close click');

    this.equipamentoRDService.deleteById(id).subscribe(

      (response: any) => {

        if (response.success == true) {
          this.toastr.success(response.message);
        } else {
          this.toastr.warning(response.message);
        }
        this.reset();
        this.getAll();
      },
      (error: any) => {
        this.showError(error);
      }
    );
  }

  public showError(error: any) {

    this.form.get('nome').setErrors({ hasError: true });

    if (error.error.errors) {
      this.toastr.error(error.error.errors[0].message);
    } else {
      this.toastr.error('Ocorreu um erro no servidor');
    }

    this.isProcessing = false;
  }

}

